import { useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

/**
 * Staff who can work this store's chat, with their chat name and avatar here (LCW1). Readable
 * with `conversations.read`, so the assign menu and the department editor need no `staff.read`.
 */
export function useChatAgents(storeId: string | undefined) {
  return useQuery({
    queryKey: conversationKeys.agents(storeId ?? ''),
    queryFn: () => conversationsApi.agents(storeId ?? ''),
    staleTime: 5 * 60_000,
    enabled: Boolean(storeId),
  });
}
